/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Signin1Inputs */

const en_us2_nav_signin1 = /** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_es2_nav_signin1 = /** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const es_mx2_nav_signin1 = /** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const ru_nav_signin1 = /** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const id_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const ms_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const da_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const de_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const fil_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const fr_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const it_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const hu_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const nl_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const no_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const pl_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const pt_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const pt_br2_nav_signin1 = pt_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const ro_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const fi_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const sv_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const vi_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const tr_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const cs_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const bg_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const uk_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const ar_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const hi_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const th_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const ja_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const zh_cn2_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const zh_hant1_nav_signin1 = en_us2_nav_signin1;

/** @type {(inputs: Nav_Signin1Inputs) => LocalizedString} */
const ko_nav_signin1 = en_us2_nav_signin1;

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Nav_Signin1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_signin1 = /** @type {((inputs?: Nav_Signin1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Signin1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_signin1(inputs)
	if (locale === "ms") return ms_nav_signin1(inputs)
	if (locale === "da") return da_nav_signin1(inputs)
	if (locale === "de") return de_nav_signin1(inputs)
	if (locale === "en-US") return en_us2_nav_signin1(inputs)
	if (locale === "es-ES") return es_es2_nav_signin1(inputs)
	if (locale === "es-MX") return es_mx2_nav_signin1(inputs)
	if (locale === "fil") return fil_nav_signin1(inputs)
	if (locale === "fr") return fr_nav_signin1(inputs)
	if (locale === "it") return it_nav_signin1(inputs)
	if (locale === "hu") return hu_nav_signin1(inputs)
	if (locale === "nl") return nl_nav_signin1(inputs)
	if (locale === "no") return no_nav_signin1(inputs)
	if (locale === "pl") return pl_nav_signin1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_signin1(inputs)
	if (locale === "pt") return pt_nav_signin1(inputs)
	if (locale === "ro") return ro_nav_signin1(inputs)
	if (locale === "fi") return fi_nav_signin1(inputs)
	if (locale === "sv") return sv_nav_signin1(inputs)
	if (locale === "vi") return vi_nav_signin1(inputs)
	if (locale === "tr") return tr_nav_signin1(inputs)
	if (locale === "cs") return cs_nav_signin1(inputs)
	if (locale === "bg") return bg_nav_signin1(inputs)
	if (locale === "ru") return ru_nav_signin1(inputs)
	if (locale === "uk") return uk_nav_signin1(inputs)
	if (locale === "ar") return ar_nav_signin1(inputs)
	if (locale === "hi") return hi_nav_signin1(inputs)
	if (locale === "th") return th_nav_signin1(inputs)
	if (locale === "ja") return ja_nav_signin1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_signin1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_signin1(inputs)
	return ko_nav_signin1(inputs)
});
export { nav_signin1 as "nav.signIn" }